var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-panel" },
    [
      _c(
        "el-form",
        { attrs: { inline: true } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("dos.filter.transfer_request_type") } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: _vm.$t("dos.filter.placeholder_type"),
                    clearable: "",
                  },
                  model: {
                    value: _vm.filters.transfer_request_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "transfer_request_type", $$v)
                    },
                    expression: "filters.transfer_request_type",
                  },
                },
                _vm._l(_vm.typeOptions, function (option) {
                  return _c("el-option", {
                    key: option.value,
                    attrs: { label: option.label, value: option.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("dos.filter.mac_address") } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.$t("dos.filter.placeholder_mac"),
                  maxlength: "17",
                },
                model: {
                  value: _vm.filters.mac_address,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "mac_address", $$v)
                  },
                  expression: "filters.mac_address",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("dos.filter.status") } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: _vm.$t("dos.filter.placeholder_status"),
                    clearable: "",
                  },
                  model: {
                    value: _vm.filters.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "status", $$v)
                    },
                    expression: "filters.status",
                  },
                },
                _vm._l(_vm.statusOptions, function (option) {
                  return _c("el-option", {
                    key: option.value,
                    attrs: { label: option.label, value: option.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.applyFilters } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("dos.filter.apply")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.clearFilters } }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("dos.filter.clear")) + "\n      "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }